import { useContext, useMemo } from 'react';
import eurekaMgrs from '@eureka/ui-managers';
import { ConfigContext } from '../context';

const { FragmentManager } = eurekaMgrs;

/**
 * @function useFragmentsWithTag
 * @description Custom React Hook to retrieve a fragment component with just the tag name
 */
export function useFragmentsWithTag(tagName) {
  const config = useContext(ConfigContext);

  return useMemo(() => {
    const components = (config || {}).components || [];
    return FragmentManager.getFragmentsWithTag(tagName, {
      ...(config || {}),
      components,
    })
  }, [tagName, config]);
}
